import {remCalc} from '_themeUtils'

const navigationStylesCommons = {
    height: 'auto',
    width: 'auto',
    pos: 'unset',
    p: 'spacing.2',
    _after: {
        display: 'none',
    },
}

const productTileOverlay = {
    ProductTileOverlay: {
        baseStyle: () => ({
            wrapper: {
                pos: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                maxH: {base: remCalc(430), md: 'auto'},
                pt: 'spacing.4',
                px: {base: 'spacing.6', md: 'spacing.4'},
                pb: 'spacing.8',
                bg: {base: 'color.background.sizeSelector.default', md: 'color.background.sizeSelector.desktop'},
                gap: 'spacing.none',
                zIndex: 'dropdown',
            },
            selectionTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(0.6),
                mb: 'spacing.5',
            },
            selectionTitleError: {
                color: 'color.text.error',
            },
            addToCartButtonWrapper: {
                pos: 'relative',
                w: 'full',
            },
            addToCartNoSizeWrapper: {
                pos: 'absolute',
                w: 'full',
                left: 0,
                right: 0,
                textAlign: 'center',
            },
            addToCartNoSize: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                color: 'color.text.error',
            },
            swiperWrapper: {
                w: '100%',
                maxW: '100%',
                sx: {
                    '.swiper': {
                        margin: 0,
                    },
                    '.swiper-slide': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                },
            },
            navigationPrev: {
                ...navigationStylesCommons,
            },
            navigationNext: {
                ...navigationStylesCommons,
            },
            hasActiveArrow: {
                sx: {
                    svg: {
                        transform: 'rotate(180deg)',
                    },
                },
            },
            mobileTogglesRow: {
                w: '100%',
                alignItems: 'center',
                py: 'spacing.4',
                pl: 'spacing.2',
                // mb: 'spacing.4',
                borderTop: '1px solid',
                // borderBottom: '1px solid',
                borderColor: 'color.border.grey.300',
            },
            colorImageToggler: {
                maxW: remCalc(33),
                minW: remCalc(33),
                minH: remCalc(41),
                border: '1px solid',
                borderColor: 'color.border.black',
            },
            separator: {
                w: remCalc(3),
                h: remCalc(41),
                bg: 'color.background.grey.300',
                mx: 'spacing.2',
            },
            sizeLabelToggler: {
                textStyle: 'paragraphXs',
                // textTransform: 'uppercase',
                letterSpacing: remCalc(3),
                color: 'color.text.black',
                fontWeight: 400,
            },
            colorsRowWrapper: {
                w: '100%',
                alignItems: 'flex-start',
                pb: 'spacing.6',
                borderBottom: {md: '1px solid'},
                borderColor: {md: 'color.border.grey.300'},
            },
            colorsRow: {
                alignItems: 'flex-start',
                columnGap: 'spacing.6',
                flexWrap: 'wrap',
            },
            colorWrapper: {
                gap: 0,
                minW: {base: remCalc(53), lg: remCalc(50)},
                maxW: {base: remCalc(53), lg: remCalc(50)},
                minH: remCalc(95),
            },
            colorImage: {
                minW: remCalc(50),
                minH: remCalc(60),
                objectFit: 'cover',
                cursor: 'pointer',
            },
            colorImageSelected: {
                border: '1px solid',
                borderColor: 'color.border.black',
            },
            colorName: {
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(0.9),
                fontWeight: 400,
                textAlign: 'center',
                mt: 'spacing.1',
            },
            addToCartRow: {
                w: '100%',
                pt: 'spacing.4',
                gap: 'spacing.6',
                borderTop: '1px solid',
                borderColor: 'color.border.grey.300',
            },
            rangeRealPrice: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(0.8),
                whiteSpace: 'nowrap',
            },
        }),
        variants: {
            wishlist: {
                wrapper: {
                    h: 'full',
                    maxH: 'full',
                    pt: {base: 'spacing.7', md: 'spacing.7'},
                    pb: {base: 'spacing.10', md: 'spacing.10'},
                    px: {base: 'spacing.6', md: 'spacing.14'},
                    overflowY: 'auto',
                    bg: 'color.background.sizeSelector.desktop',
                },
                productNotAvailableWrapper: {
                    w: 'full',
                    h: 'full',
                    justify: 'center',
                    align: 'center',
                    spacing: 'spacing.3',
                    textAlign: 'center',
                },
                notAvailableLabel: {
                    textStyle: 'paragraphMd',
                    fontWeight: 400,
                },
                shareContainer: {
                    spacing: 'spacing.4',
                    align: 'flex-start',
                },
                shareLabel: {
                    textStyle: 'paragraphXs',
                    fontWeight: 400,
                    letterSpacing: remCalc(3),
                    textTransform: 'uppercase',
                },
                shareButton: {
                    cursor: 'pointer',
                    spacing: 'spacing.2',
                },
                skuLabel: {
                    textStyle: 'paragraphXs',
                    color: 'color.text.grey.600',
                },
                overlayMainContent: {
                    w: 'full',
                    flexGrow: 1,
                    align: 'flex-start',
                    justify: 'center',
                    spacing: 0,
                },
                selectedColorLabel: {
                    textStyle: 'paragraphMd',
                    fontWeight: 400,
                    letterSpacing: remCalc(0.6),
                    mb: {base: 'spacing.1', xl: 'spacing.4'},
                },
                selectedColor: {
                    textTransform: 'uppercase',
                },
                selectedSizeLabel: {
                    textStyle: 'paragraphMd',
                    fontWeight: 400,
                    letterSpacing: remCalc(0.6),
                    mb: 'spacing.12',
                },
                addProductToCartWrapper: {
                    position: 'relative',
                    w: 'full',
                },
                goToProductButton: {
                    mt: 'spacing.5',
                    mx: 'auto',
                },
            },
        },
    },
}

export default productTileOverlay
